import './download.scss';
import { useGenericTableStore } from "@stores/useGenericTableStore";
import { formatFilterDataForApi } from "@components/filters/colFilters";
import { Spin } from 'antd';
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
import { useMemo } from "react";
import Icon from "@assets/icon_config";

const DefaultButton = ({disabled = false}) => {
  return (
    <div className={`download ${disabled ? 'download-disabled' : ''}`}>
      <Icon name="report-download" colorOfBrand={disabled ? '#838EA0' : ''}/>
      <span>Download Report</span>
    </div>
  );
};

function DownLoad({children , onClick , className , loader = false , filteredInfo = {}} : any) {

  const tableParams = useGenericTableStore((state) => state.tableParams);
  const data = useGenericTableStore((state) => state.data);
  const filters = formatFilterDataForApi(filteredInfo);

  const disabled = useMemo(() => {
    return !(data?.length > 0)
  },[data?.length]);

  const handleOnclick = () => {
    if(!disabled) {
      onClick({filters , sortByCol : tableParams.field , sortType : tableParams?.order})
    }
    return;
  }

  return (
    <div className={className} onClick={() => handleOnclick()}>
        <Spin spinning={loader} indicator={<HealthemSpinner/>}>{children ? children : <DefaultButton disabled={disabled}/>}</Spin>
    </div>
  );
}

export default DownLoad;